<!-- Model Onboarding Checklist -->
<ng-container *ngIf="isVisible && !isLoading">
  <!-- Onboarding checklist when profile is incomplete -->
  <mat-card class="onboarding-card">
    <mat-card-header>
      <mat-card-title>Complete Your Profile</mat-card-title>
      <mat-card-subtitle>
        Stand out to potential clients by completing your profile
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <!-- Progress bar -->
      <div class="progress-section">
        <div class="progress-header">
          <span class="progress-label">Profile Completion</span>
          <span class="progress-value">{{ progressPercentage }}%</span>
        </div>
        <mat-progress-bar
          mode="determinate"
          [value]="progressPercentage"
          class="progress-bar"
          [ngClass]="{'progress-low': progressPercentage < 40, 'progress-medium': progressPercentage >= 40 && progressPercentage < 70, 'progress-high': progressPercentage >= 70}"
        ></mat-progress-bar>
      </div>

      <!-- Checklist items -->
      <ul class="checklist">
        <li *ngFor="let item of checklistItems" class="checklist-item" [ngClass]="{'completed': item.isComplete}">
          <mat-icon 
            [fontIcon]="getItemIcon(item)" 
            [ngClass]="getItemIconClass(item)"
          ></mat-icon>
          <span class="item-label">
            {{ item.label }}
            <span *ngIf="item.isOptional" class="optional-badge">Optional</span>
          </span>
          <button 
            *ngIf="!item.isComplete && item.routerLink"
            mat-button 
            color="primary" 
            class="improve-btn"
            (click)="navigateToImprove(item)"
          >
            Improve
          </button>
        </li>
      </ul>
    </mat-card-content>
  </mat-card>
</ng-container>

<!-- Loading state -->
<ng-container *ngIf="isLoading">
  <mat-card class="onboarding-card loading-card">
    <mat-card-content class="loading-content">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Loading profile...</span>
    </mat-card-content>
  </mat-card>
</ng-container>